function sliderListProducts (slider) {
  var swiperName = ".listCollectionSwiper-" + $(slider).attr('data-section-id');
  var swiperpagination = ".js-list-collection-swiper-pagination-" + $(slider).attr('data-section-id');
  var swipernextEl = ".js-list-collection-swiper-button-next-" + $(slider).attr('data-section-id');
  var swiperprevEl = ".js-list-collection-swiper-button-prev-" + $(slider).attr('data-section-id');
  var swiperPerView = $(slider).attr('data-swiper-slides');
  var swiper = new Swiper(swiperName, {
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: true,
    loop: false,
    pagination: {
      el: swiperpagination,
      clickable: true,
    },
    navigation: {
      nextEl: swipernextEl,
      prevEl: swiperprevEl,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 3,
        centeredSlides: false
      },
      1024: {
        slidesPerView: swiperPerView,
        centeredSlides: false
      },
    },
  });
}

$('.listCollectionSwiper').each(function(index, el) {
  sliderListProducts(el);
});